export default "__VITE_ASSET__Cb$FdplB__"